<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-code`]" width="1em" height="1em" v-bind="$attrs"><path d="M2.82973 3.99712C3.41547 3.41169 4.36512 3.41164 4.95082 3.99712L8.76137 7.80766C8.94171 7.988 9.14144 8.18621 9.29848 8.37114C9.4669 8.56952 9.6719 8.84944 9.79458 9.22661C9.95772 9.72872 9.95772 10.2704 9.79458 10.7725C9.6719 11.1497 9.46692 11.4296 9.29848 11.628C9.14144 11.8129 8.94172 12.0111 8.76137 12.1915L4.95082 16.002C4.3651 16.5876 3.41549 16.5875 2.82973 16.002C2.24409 15.4163 2.24412 14.4667 2.82973 13.8809L6.64028 10.0704C6.66471 10.0459 6.68681 10.0219 6.70864 10C6.68669 9.97806 6.66487 9.95335 6.64028 9.92876L2.82973 6.11919C2.24398 5.53343 2.24405 4.58291 2.82973 3.99712ZM16.11 13.4415C16.9384 13.4415 17.61 14.1131 17.61 14.9415C17.6099 15.7697 16.9383 16.4414 16.11 16.4415H11.1413C10.3129 16.4415 9.64139 15.7698 9.64125 14.9415C9.64125 14.113 10.3128 13.4415 11.1413 13.4415H16.11Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillCode',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
